export function filterTopics(tableData) {
    const filtered = tableData.filter((el) => el.totalTenants >= 0);
    return filtered;
}
